var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Game',{attrs:{"cards":[
        "container-do",
        "database",
        "vm-2",
        "redhat-2",
        "storage",
        "memory",
        "mac",
        "what-is-image",
        "host",
        "image-files",
        "access-files" ],"basedir":"container-basics","title":"container flashcards"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }